import { useState } from "react";
import {
  FaLinkedinIn,
  FaTwitter,
  FaInstagram,
  FaFacebookF,
} from "react-icons/fa";
import LoginModal from "./LoginModal";
const navItems = [
  { label: "Discover Finncube", href: "#/", route: "home" },
  { label: "How It Works", href: "#/banking", route: "banking" },
  { label: "Why Finncube", href: "#/retail", route: "retail" },
  { label: "Partner Network", href: "#/services", route: "services" },
  // { label: "Security", href: "#/software", route: "software" },
  { label: "Experience Finncube", href: "#/media", route: "media" },
  { label: "Talk to Us", href: "#/locate", route: "locate" },
  // { label: "Company", href: "#/company", route: "company" },
  { label: "Our Story", href: "#/about", route: "about" },
  { label: "Apply Now", href: "https://web.finncube.com/", route: "external-login", isExternal: true },
];

const directionsUrl =
  "https://www.google.com/maps/dir/?api=1&destination=9th+Floor,+954/AB,+JMD+Megapolis,+Sohna+Road,+Gurugram,+Haryana,122018&travelmode=driving";
const socialLinks = [
  { href: "https://www.linkedin.com/company/113027997/admin/notifications/all/", label: "LinkedIn", icon: FaLinkedinIn },
  { href: "https://x.com/FinnCube_Tech", label: "Twitter", icon: FaTwitter },
  {
    href: "https://www.instagram.com/finncube_credit?utm_source=qr&igsh=MW1oM2E1ZGY3aWE4",
    label: "Instagram",
    icon: FaInstagram,
  },
  {
    href: "https://www.facebook.com/share/176MvMKS4X/",
    label: "Facebook",
    icon: FaFacebookF,
  },
];
const exploreLinks = [
  { href: "#/career", label: "Career" },
  { href: "#/policies", label: "Policies" },
  { href: "#/locate", label: "Locate Us" },
];
const legalLinks = [
  { href: "#/privacy-policy", label: "Privacy Policy" },
  { href: "#/grievance-policy", label: "Grievance Policy" },
  { href: "#/cookies-policy", label: "Cookies Policy" },
  // { href: "#/refund-policy", label: "Refund Policy" },
  { href: "#/terms-and-conditions", label: "Terms and Conditions" },
  // { href: "#/interest-rate-policy", label: "Interest Rate Charges Policy" },
  // { href: "#/info-policy", label: "Information Security Policy" },
  // { href: "#/kyc-policy", label: "KYC & AML Policy" },
  // { href: "#/media", label: "Media Policy" },
  // { href: "#/social", label: "Social Media Policy" },
  // { href: "#/risk", label: "Risk Management Policy" },
];

function SiteShell({
  route,
  heroTag,
  heroTitle,
  heroText,
  heroImage,
  heroQrImage,
  heroActions = [],
  heroVariant = "default",
  heroHighlights = [],
  heroHidden = false,
  highlightsHidden = false,
  children,
}) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const handleFooterLinkClick = (event) => {
    const link = event.target.closest("a");
    if (!link) return;

    const href = link.getAttribute("href") || "";
    if (href.startsWith("#/")) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };
  const openLoginModal = (event) => {
    event.preventDefault();
    setIsLoginOpen(true);
  };
  const scrollToTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };
  const handleNavItemClick = (event, item, isMobile = false) => {
    if (item.isExternal || item.href.startsWith("http://") || item.href.startsWith("https://")) {
      if (isMobile) setMenuOpen(false);
      return;
    }
    if (item.route === "login") {
      openLoginModal(event);
      if (isMobile) setMenuOpen(false);
      return;
    }
    if (item.route === "user") {
      event.preventDefault();
      window.location.href = item.href;
      if (isMobile) setMenuOpen(false);
      return;
    }
    scrollToTop();
    if (isMobile) setMenuOpen(false);
  };

  const isHeroVideo =
    typeof heroImage === "string" &&
    (heroImage.toLowerCase().endsWith(".mp4") ||
      heroImage.toLowerCase().endsWith(".webm"));

  return (
    <div className="min-h-screen bg-[#f8fbff] text-slate-900 selection:bg-[#fb923c] selection:text-white">
      {/* <div className="bg-[#0a2c4e] px-4 py-2 text-center text-[9px] font-bold uppercase tracking-[0.14em] text-white/90 sm:px-5 sm:text-[10px] md:px-8 md:tracking-[0.2em]">
        India&apos;s First Instant Personal Loan kiosk for Salaried         CIN-No- U66190HR2026PTC144688           
      </div> */}


      <div className="bg-[#0a2c4e] px-4 py-2 text-[9px] font-bold uppercase tracking-[0.14em] text-white/90 sm:px-5 sm:text-[10px] md:px-8 md:tracking-[0.2em]">
        <span style={{ display: "block", textAlign: "center" }}>
          India's First Instant Personal Loan kiosk for Salaried
        </span>

        <span style={{ display: "block", textAlign: "right" }}>
          CIN-No- U66190HR2026PTC144688
        </span>

      </div>

      {/* Top Banner - Apply Now */}
      <a
        href="https://web.finncube.com/"
        target="_blank"
        rel="noopener noreferrer"
        className="group relative flex items-center justify-center overflow-hidden bg-gradient-to-r from-[#e37921] via-[#f59e0b] to-[#e37921] px-4 py-2.5 text-white shadow-md transition-all duration-300 hover:brightness-105 animate-apply-shimmer"
      >
        <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-4 text-center text-xs sm:text-sm font-bold tracking-wide">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-white/20 px-2.5 py-0.5 text-[10px] sm:text-xs font-black uppercase tracking-wider text-white backdrop-blur-sm">
            <span className="h-2 w-2 rounded-full bg-white animate-pulse" />
            Instant Loan
          </span>
          <span>Apply for Personal Loans up to ₹1 Lakh in 3 Minutes!</span>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-white px-3.5 py-1 text-xs font-extrabold text-[#0a2c4e] shadow-sm transition-all duration-200 group-hover:scale-105 group-hover:bg-slate-100 animate-apply-pulse">
            Apply Now
            <svg className="h-3.5 w-3.5 fill-current text-[#e37921] animate-arrow-nudge" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </span>
        </div>
      </a>

      <header className="sticky top-0 z-50 border-b border-white/20 bg-white/70 backdrop-blur-xl transition-all duration-300">
        <div className="flex min-h-[98px] w-full items-center gap-4 pl-2 pr-4 sm:pl-3 sm:pr-6 md:min-h-[116px] md:pl-4 md:pr-8">
          <a
            href="#/"
            className="group flex items-center gap-3 text-[26px] font-bold tracking-tight"
          >
            <div className="ml-0 flex items-center gap-2 overflow-visible">
              <img
                src="/finncube_logo2_transparent.png"
                alt="FinnCube Logo"
                className="h-auto w-[170px] origin-left object-contain sm:w-[205px] md:w-[250px]"
              />
            </div>
          </a>

          <nav className="hidden flex-1 items-center justify-evenly gap-3 pl-4 text-[12px] font-extrabold uppercase leading-snug tracking-[0.12em] text-[#1f3f62] lg:flex xl:gap-4 xl:text-[13px]">
            {navItems.map((item) =>
              item.label === "Apply Now" ? (
                <a
                  key={item.route}
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="relative flex items-center justify-center rounded-full bg-[#e37921] px-5 py-2 text-center text-white font-extrabold tracking-wider shadow-md transition-all duration-300 hover:bg-[#c96414] hover:shadow-lg hover:scale-105 animate-apply-shimmer animate-apply-pulse"
                >
                  {item.label}
                </a>
              ) : item.route === "company" ? (
                <div key={item.route} className="group relative">
                  <a
                    href={item.href}
                    onClick={(event) => handleNavItemClick(event, item)}
                    className={`relative flex min-h-12 min-w-[92px] items-center justify-center px-2 py-1 text-center transition-all duration-300 hover:text-[#e37921] xl:min-w-[104px] ${route === item.route
                      ? "text-[#e37921] after:absolute after:bottom-0 after:left-0 after:h-[2px] after:w-full after:bg-[#e37921]"
                      : "after:absolute after:bottom-0 after:left-0 after:h-[2px] after:w-0 after:bg-[#e37921] after:transition-all after:duration-300 hover:after:w-full"
                      }`}
                  >
                    {item.label}
                  </a>
                </div>
              ) : (
                <a
                  key={item.route}
                  href={item.href}
                  onClick={(event) => handleNavItemClick(event, item)}
                  className={`relative flex min-h-12 min-w-[92px] items-center justify-center px-2 py-1 text-center transition-all duration-300 hover:text-[#e37921] xl:min-w-[104px] ${route === item.route
                    ? "text-[#e37921] after:absolute after:bottom-0 after:left-0 after:h-[2px] after:w-full after:bg-[#e37921]"
                    : "after:absolute after:bottom-0 after:left-0 after:h-[2px] after:w-0 after:bg-[#e37921] after:transition-all after:duration-300 hover:after:w-full"
                    }`}
                >
                  {item.label}
                </a>
              ),
            )}
          </nav>

          <div className="ml-auto flex items-center gap-4 lg:ml-0">
            <button
              type="button"
              aria-label="Toggle navigation"
              aria-expanded={menuOpen}
              className="group relative flex h-10 w-10 flex-col items-center justify-center gap-1.5 lg:hidden"
              onClick={() => setMenuOpen((prev) => !prev)}
            >
              <span
                className={`h-0.5 w-6 bg-[#1f3f62] transition-all duration-300 ${menuOpen ? "translate-y-2 rotate-45" : ""}`}
              />
              <span
                className={`h-0.5 w-6 bg-[#1f3f62] transition-opacity duration-300 ${menuOpen ? "opacity-0" : ""}`}
              />
              <span
                className={`h-0.5 w-6 bg-[#1f3f62] transition-all duration-300 ${menuOpen ? "-translate-y-2 -rotate-45" : ""}`}
              />
            </button>
          </div>
        </div>

        {menuOpen ? (
          <nav className="border-t border-slate-100 bg-white/95 px-6 py-6 backdrop-blur-lg lg:hidden">
            <div className="mx-auto flex max-w-md flex-col gap-4 text-center text-xs font-bold uppercase tracking-[0.2em] text-[#1f3f62]">
              {navItems.map((item) => (
                <div key={item.route}>
                  <a
                    href={item.href}
                    target={item.isExternal ? "_blank" : undefined}
                    rel={item.isExternal ? "noopener noreferrer" : undefined}
                    className={`block py-2 transition-colors ${
                      item.label === "Apply Now"
                        ? "rounded-full bg-[#e37921] text-white text-center font-extrabold py-2.5 shadow-md hover:bg-[#c96414]"
                        : route === item.route
                        ? "text-[#e37921]"
                        : "hover:text-[#e37921]"
                    }`}
                    onClick={(event) => handleNavItemClick(event, item, true)}
                  >
                    {item.label}
                  </a>
                </div>
              ))}
            </div>
          </nav>
        ) : null}
      </header>

      <main>
        {!heroHidden && (
          <section className="relative min-h-[460px] overflow-hidden bg-[#061a2e] pb-16 pt-12 text-white sm:pb-20 sm:pt-14 md:pb-32 md:pt-20 lg:pt-28">
            {/* Animated Background Elements */}
            <div className="absolute inset-0 z-0">
              <div className="absolute -left-[10%] -top-[10%] h-[60%] w-[60%] rounded-full bg-[#0a3156] opacity-40 blur-[120px]" />
              <div className="absolute -right-[5%] top-[20%] h-[50%] w-[50%] rounded-full bg-[#124d77] opacity-30 blur-[100px]" />
              <div className="absolute bottom-0 left-[20%] h-[40%] w-[40%] rounded-full bg-[#df1f2d] opacity-[0.08] blur-[80px]" />
              <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-[0.03]" />
            </div>

            <div className="relative z-10 mx-auto grid max-w-[1280px] items-center gap-10 px-4 sm:px-6 md:px-10 lg:grid-cols-[1.1fr_0.9fr] lg:gap-12">
              <div className="text-center lg:text-left">
                <span className="inline-flex rounded-full bg-white/10 px-3 py-1.5 text-[9px] font-black uppercase tracking-[0.18em] text-sky-300 ring-1 ring-white/20 backdrop-blur-md sm:px-4 sm:text-[10px] sm:tracking-[0.25em]">
                  {heroTag}
                </span>
                <h1 className="mt-5 text-3xl font-extrabold leading-[1.15] tracking-tight sm:text-4xl md:mt-6 md:text-6xl xl:text-7xl">
                  {heroTitle}
                </h1>
                <p className="mt-6 max-w-2xl text-sm leading-relaxed text-sky-100/80 sm:text-base md:mt-8 md:text-lg lg:mx-0">
                  {heroText}
                </p>
                <div className="mt-10 flex flex-wrap justify-center gap-4 text-[11px] font-black uppercase tracking-[0.15em] lg:justify-start">
                  {heroActions.map((action) => (
                    <a
                      key={action.label}
                      href={action.href}
                      className={
                        action.primary
                          ? "group relative flex items-center gap-2 overflow-hidden rounded-full bg-white px-8 py-4 text-[#0a2c4f] transition-all hover:-translate-y-1 hover:shadow-[0_20px_40px_-10px_rgba(255,255,255,0.3)]"
                          : "group flex items-center gap-2 rounded-full border border-white/30 bg-white/5 px-8 py-4 text-white backdrop-blur-md transition-all hover:bg-white/15 hover:shadow-lg"
                      }
                    >
                      {action.label}
                      {action.primary && (
                        <span className="transition-transform group-hover:translate-x-1">
                          →
                        </span>
                      )}
                    </a>
                  ))}
                </div>
              </div>

              <div className="relative group mx-auto w-full max-w-lg lg:max-w-none">
                <div className="absolute -inset-1 rounded-2xl bg-gradient-to-tr from-[#12a9bf] to-[#df1f2d] opacity-20 blur-2xl transition duration-500 group-hover:opacity-40" />
                <div className="relative">
                  {isHeroVideo ? (
                    <video
                      src={heroImage}
                      className="relative h-[260px] w-full rounded-2xl border border-white/10 bg-slate-900 object-cover shadow-[0_30px_60px_-15px_rgba(0,0,0,0.5)] transition duration-500 group-hover:scale-[1.02] sm:h-[320px] md:h-[420px]"
                      autoPlay
                      muted
                      loop
                      playsInline
                    />
                  ) : (
                    <img
                      src={heroImage}
                      alt="Loan kiosk product"
                      className="relative h-[260px] w-full rounded-2xl border border-white/10 bg-slate-900 object-cover shadow-[0_30px_60px_-15px_rgba(0,0,0,0.5)] transition duration-500 group-hover:scale-[1.02] sm:h-[320px] md:h-[420px]"
                    />
                  )}
                  <div className="absolute -bottom-4 left-3 rounded-2xl border border-white/10 bg-[#082f52]/90 p-4 shadow-2xl backdrop-blur-xl sm:-bottom-6 sm:-left-6 sm:p-5">
                    <p className="text-[10px] font-bold uppercase tracking-widest text-sky-300">
                      Fast Decision
                    </p>
                    <p className="mt-1 text-xl font-black text-white">
                      Under 3 Minutes
                    </p>
                  </div>
                </div>
                {heroQrImage && (
                  <div className="relative z-10 mx-auto mt-9 flex w-fit flex-col items-center gap-3 sm:mt-10">
                    <div className="rounded-xl border border-white/10 bg-white p-2 shadow-lg">
                      <img
                        src={heroQrImage}
                        alt="Scan to continue your FinnCube journey"
                        className="h-24 w-24 object-contain sm:h-28 sm:w-28"
                      />
                    </div>
                    <span className="text-sm font-black uppercase tracking-[0.14em] text-sky-100 sm:text-base">
                      Locate Us
                    </span>
                  </div>
                )}
                {/* <div className="absolute -right-4 -top-4 hidden rounded-2xl border border-white/10 bg-white/5 p-4 shadow-2xl backdrop-blur-md md:block">
                  <div className="flex items-center gap-2">
                    <span className="h-2 w-2 animate-pulse rounded-full bg-green-400" />
                    <span className="text-[11px] font-bold uppercase tracking-widest text-white">
                      Live Operations
                    </span>
                  </div>
                </div> */}
              </div>
            </div>
          </section>
        )}

        {!highlightsHidden && (
          <section className="relative z-20 mx-auto -mt-8 max-w-[1280px] px-4 sm:-mt-12 sm:px-6 md:px-10">
            <div className="grid gap-4 rounded-3xl border border-slate-200 bg-white/80 p-4 shadow-[0_20px_50px_-12px_rgba(10,44,79,0.12)] backdrop-blur-2xl md:grid-cols-4 lg:p-6">
              {(heroHighlights.length
                ? heroHighlights
                : [
                  { label: "Loan Decision Time", value: "In Minutes" },
                  { label: "Built For", value: "Salaried Professionals" },
                  { label: "Security & Trust", value: "Bank-Grade Security" },
                  { label: "Service Availability", value: "99.99% Reliable" },
                ]
              ).map((item) => (
                <article
                  key={item.label}
                  className="group relative rounded-2xl bg-slate-50/50 p-6 transition-all hover:bg-white hover:shadow-xl"
                >
                  <div className="absolute left-0 top-1/2 h-8 w-1 -translate-y-1/2 rounded-r-full bg-[#e37921] opacity-0 transition-opacity group-hover:opacity-100" />
                  <p className="text-[15px] font-black uppercase tracking-[0.2em] text-[#e37921]/80">
                    {item.label}
                  </p>
                  <h3 className="mt-2 text-xl font-extrabold text-[#0a2c4f] tracking-tight">
                    {item.value}
                  </h3>
                </article>
              ))}
            </div>
          </section>
        )}

        {children}
      </main>

      <footer
        className="mt-16 border-t border-white/10 bg-gradient-to-b from-[#040d17] via-[#071223] to-[#050c16] pb-14 pt-14 text-slate-300 sm:mt-20 sm:pb-16 sm:pt-16"
        onClick={handleFooterLinkClick}
      >
        <div className="mx-auto max-w-[1360px] px-4 sm:px-6 md:px-10">
          <div className="rounded-3xl border border-white/10 bg-white/[0.03] p-5 shadow-[0_24px_60px_-30px_rgba(0,0,0,0.7)] backdrop-blur-xl sm:p-7 md:p-10">
            <div className="grid gap-8 md:grid-cols-2 xl:grid-cols-12">
              <div className="space-y-5 md:col-span-2 xl:col-span-5">
                <a href="#/" className="inline-flex items-center leading-none">
                  <img
                    src="/finncube_logo2_transparent.png"
                    alt="FinnCube Logo"
                    className="h-auto w-[139px] object-contain md:w-[185px]"
                  />
                </a>
                <p className="max-w-[420px] text-sm leading-relaxed text-slate-300">
                  Revolutionizing digital credit accessibility across India.
                  FinnCube is building the future of autonomous retail finance for
                  everyone.
                </p>
                <div className="flex flex-wrap gap-3">
                  {socialLinks.map(({ href, label, icon: Icon }) => (
                    <a
                      key={label}
                      href={href}
                      aria-label={label}
                      className="flex h-10 w-10 items-center justify-center rounded-xl border border-white/15 bg-white/5 text-white transition hover:-translate-y-0.5 hover:border-[#e37921] hover:bg-[#e37921]"
                    >
                      <Icon size={15} />
                    </a>
                  ))}
                </div>
                <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-slate-500">
                  CIN-No- U66190HR2026PTC144688
                </p>
              </div>

              <div className="rounded-2xl border border-white/10 bg-white/[0.02] p-5 md:p-6 xl:col-span-2">
                <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-[#e37921]">
                  Explore
                </h3>
                <ul className="mt-5 space-y-3 text-sm">
                  {exploreLinks.map((link) => (
                    <li key={link.href}>
                      <a href={link.href} className="transition-colors hover:text-white">
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="rounded-2xl border border-white/10 bg-white/[0.02] p-5 md:p-6 xl:col-span-2">
                <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-[#e37921]">
                  Legal
                </h3>
                <ul className="mt-5 space-y-3 text-sm">
                  {legalLinks.map((link) => (
                    <li key={link.href}>
                      <a href={link.href} className="transition-colors hover:text-white">
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="rounded-2xl border border-white/10 bg-white/[0.02] p-5 md:p-6 xl:col-span-3">
                <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-[#e37921]">
                  Direct Connect
                </h3>
                <div className="mt-5 space-y-4 text-sm">
                  <div className="flex gap-3">
                    <span className="mt-1 flex-shrink-0 text-[#df1f2d]">📍</span>
                    <p className="text-slate-300">
                      9th Floor, 954/AB, JMD Megapolis, Sohna Road, Gurugram, Haryana,122018
                    </p>
                  </div>
                  <div className="flex gap-3">
                    <span className="mt-1 flex-shrink-0 text-[#e37921]">✉️</span>
                    <div className="inline-flex flex-col items-stretch space-y-2">
                      <a
                        href="mailto:care@finncube.com"
                        className="block text-slate-300 transition-colors hover:text-white"
                      >
                        care@finncube.com
                      </a>
                      {/* <a
                        href="tel:+919997842548"
                        className="flex h-8 w-full items-center justify-center rounded-lg border border-white/15 bg-white/5 text-[#e37921] transition-colors hover:border-[#e37921] hover:bg-[#e37921] hover:text-white"
                        aria-label="Call FinnCube at 9997842548"
                        title="Call FinnCube"
                      >
                        <FaPhoneAlt size={13} />
                      </a> */}
                      {/* <a
                        href="tel:+918510014401"
                        className="block text-slate-300 transition-colors hover:text-white"
                      >
                        ☎︎ +91 8510014401
                      </a> */}
                    </div>
                  </div>
                  <div className="flex gap-3">
                    <span className="mt-1 flex-shrink-0">☎︎</span>
                    <div className="inline-flex flex-col items-stretch space-y-2">
                      <a
                        href="tel:+91 8510014401"
                        className="block text-slate-300 transition-colors hover:text-white"
                      >
                        +91 8510014401
                      </a>
                      {/* <a
                        href="tel:+919997842548"
                        className="flex h-8 w-full items-center justify-center rounded-lg border border-white/15 bg-white/5 text-[#e37921] transition-colors hover:border-[#e37921] hover:bg-[#e37921] hover:text-white"
                        aria-label="Call FinnCube at 9997842548"
                        title="Call FinnCube"
                      >
                        <FaPhoneAlt size={13} />
                      </a> */}
                      {/* <a
                        href="tel:+918510014401"
                        className="block text-slate-300 transition-colors hover:text-white"
                      >
                        ☎︎ +91 8510014401
                      </a> */}
                    </div>
                  </div>
                </div>
                <a
                  href={directionsUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="mt-6 inline-flex w-full items-center justify-center gap-3 rounded-xl border border-[#e37921]/40 bg-[#e37921]/10 py-3 text-xs font-bold uppercase tracking-widest text-white transition-all hover:bg-[#e37921] hover:shadow-[0_10px_20px_-5px_rgba(223,31,45,0.3)]"
                >
                  Navigate to Office <span>→</span>
                </a>
              </div>
            </div>

            <div className="mt-8 flex flex-col gap-4 border-t border-white/10 pt-6 md:flex-row md:items-center md:justify-between">
              <div className="flex flex-col gap-1">
                <p className="text-[11px] font-medium uppercase tracking-widest text-slate-500">
                  © 2026 FinnCube Credit Services Private Limited All Rights Reserved.
                </p>
                <p className="text-[9px] font-medium uppercase tracking-widest text-slate-500 md:text-[10px]">
                  Powered by Pawanshut Holdings Ltd.
                </p>
              </div>
              <div className="flex flex-wrap gap-3 text-[10px] font-medium uppercase tracking-[0.12em] text-slate-500 sm:gap-6 sm:text-[11px] sm:tracking-widest">
                {legalLinks.map((link) => (
                  <a key={link.href} href={link.href} className="hover:text-slate-300">
                    {link.label}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </footer>
      {/* Floating Apply Now Quick Action Banner */}
      <div className="fixed bottom-5 right-5 z-50 animate-float-gentle">
        <a
          href="https://web.finncube.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="group flex items-center gap-3 rounded-full border border-white/20 bg-[#0a2c4e] p-2.5 pr-5 text-white shadow-[0_10px_30px_rgba(227,121,33,0.4)] backdrop-blur-xl transition-all duration-300 hover:scale-105 hover:bg-[#061a2e] hover:shadow-[0_15px_35px_rgba(227,121,33,0.6)] animate-apply-shimmer animate-apply-pulse"
        >
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-tr from-[#e37921] to-[#f59e0b] text-white font-bold text-lg shadow-md animate-pulse">
            ⚡
          </div>
          <div className="flex flex-col text-left">
            <span className="text-[10px] font-black uppercase tracking-widest text-[#e37921]">
              Instant Loan
            </span>
            <span className="text-xs font-bold text-white group-hover:text-amber-300 transition-colors flex items-center gap-1">
              Apply Now <span className="inline-block transition-transform animate-arrow-nudge">→</span>
            </span>
          </div>
        </a>
      </div>

      {isLoginOpen ? (
        <LoginModal onClose={() => setIsLoginOpen(false)} />
      ) : null}
    </div>
  );
}

export default SiteShell;
